import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface Props {
  text: string;
}

export const StoreDealGuide = ({ text }: Props) => {
  return (
    <Guide>
      <Text variant='Body_13_Regular' color='textSecondary' style={{ lineHeight: '150%' }}>
        {text}
      </Text>
    </Guide>
  );
};

const Guide = styled.div`
  margin: 0 16px;
  padding: 14px 16px;
  border-radius: 6px;
  border: 1px solid ${vars.color.borderPrimary};
  background: ${vars.v3Color.gray50};
`;
